module.exports = __webpack_public_path__ + "media/images/restaurant/areas/kyushu_m-da92277dae99e070fb8870206997428e.png";